import api from "./axiosInstance";

export const getPromoters = async () => {
  const response = await api.get("api/v1/promoters/");
  return response.data;
};

export const getAllPromoters = async () => {
  const response = await api.get("api/v1/promoters/?limit=999");
  return response.data;
};

export const createPromoter = async (payload) => {
  const response = await api.post(
    "api/v1/promoters/",
    payload
  );
  return response.data;
};

export const deletePromoter = async (id) => {
  await api.delete(`api/v1/promoters/${id}/`);
};

export const getPromoterById = async (id) => {
  const response = await api.get(`api/v1/promoters/${id}/`);
  return response.data;
};

export const updatePromoter = async (id, payload) => {
  const response = await api.patch(
    `api/v1/promoters/${id}/`,
    payload
  );
  return response.data;
};

export const validateVat = async (payload) => {
  const response = await api.post(
    "api/v1/promoters/validate-vat/",
    payload
  );
  return response.data;
};
